/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditConversationsRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
    sampleWeek: { refreshModel: false },
    ef: { refreshModel: false },
    sortBy: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.edit.conversations',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditConversationsRoute, {
  overrideRenderTemplate: false,
});
